const arthoPageDataFields = `
  slug
  contentUrl
  metaTags
  type
`
const staticParamsFields =
  `slug
   freezeThisProfile
    profileEntity {
      status
      }`
const metaDataFields = `
    title
    profileImage{
          sizes{
            medium{
              url
            }
          }
        }
    meta{
        image{
          sizes{
            medium{
              url
            }
          }
        }
        description
        title
      }
    `

const profileCaseDataFields = `
  id
  _status
  slug
  approved
  title
  type
  coverimage{
  id
    sizes{
      webp{
        url
      }
      
    }
  }
  date
  flyerLink
  flyerSource
  shortDescription
  organizations{
    name
  }
  address
  topMedias{
    id
    title
    mimeType
    originalUrl
    source{
      title
      platform
    }
    mux{
      assetId
      playbackId
      status
    }
    handle
    coverImage{
      sizes{
        large{
          url
        }
        webp{
          url
        }
        thumbnail{
          url
        }
        medium{
          url
        }
      }
    }
    url
    sizes{
    large{
        url
    }
    thumbnail{
        url
      }
      webp{
        url
      }
      medium{
        url
      }
    }
  }
  profiles {
    id
    fullName
    _status
    publicProfile{
      id
      slug
      _status
      profileImage{
        sizes{
          webp{
            url
          }
        }
      }
      profileEntity{
        fullName
      }
    }
  }`

const individualDataFields =
  `overview
      accordionPane{
          header
          richText
        }
      updatedAt
      fixedLastUpdated
      slug
       profileImage{
          sizes{
            webp{
              url
            }
            medium{
              url
            }
          }
        }
      profileEntity {
        organizations{
          name
        }
        timeStamp{
          value
          mediaId{
            id
          }
        }
        universities{
            acronym
            name
          }
				quotes{
          quote
          reference
          socialMediaPlatform {
            platform
          }
          Date
          quoteImage{
            title
            sizes{
              webp{
                url
              }
            }
          }
          id
        }
        medias {
          id
          title
          mimeType
          source{
            title
            platform
          }
          handle
          datePosted
          backupBucketUrl
          belongToCase {
            id
          }
          parentMedia{
              id
          }
          coverImage{
            sizes{
              large{
                url
              }
              webp{
                url
              }
              thumbnail{
                url
              }
              medium{
                url
              }
            }
          }
          url
          sizes{
          large{
              url
          }
          thumbnail{
              url
            }
            webp{
              url
            }
            medium{
              url
            }
          }
          mux{
            assetId
            playbackId
            status
          }
        }
        externalVideos{
          source
          videoId
          title
          timestamp
          faceThumb{
            title
            sizes{
              webp{
                url
              }
              thumbnail{
                url
              }
              medium{
                url
              }
            }
          }
        }
        country
        usaState
        canadaState
        fullName
        status
        type
        id
        cases{
          id
          status
          case {
            ${profileCaseDataFields}
          }
        }
        socialMediaAccounts{
          platform{
            title
            platform
          }
          handle
          status
        }
        seemoreprofiles {
          relationTo
          value {
           ... on Individualprofile {
              id
              individualStatus: status
              fullName

              publicProfile {
                id
                slug
                title
                _status
                profileImage {
                sizes {
                  webp { url }
                  medium { url }
                        }
                }

              }
            }
            ... on ArthoPage {
              id
              slug
              type
              arthoStatus: status
              ecoPublicProfileId
            }
          }
        }
      }
      meta {
        description
        title
    }
    `

export { arthoPageDataFields, staticParamsFields, metaDataFields, individualDataFields, profileCaseDataFields }
